import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
} from "antd";
import React from "react";
import InventoryMasterService, {
  docType,
  Fields,
} from "../../../Services/Inventory/InventoryMasterService";
import { useClient } from "../../../Context/ClientContext";

interface props {
  onCancel: any;
  openModal: boolean;
  id: string | undefined;
  setRefresh: any;
}

const AddInventoryMaster = ({ onCancel, openModal, id, setRefresh }: props) => {
  const { currentClient } = useClient();
  const [form] = Form.useForm();

  const saveMasterData = () => {
    form.validateFields().then(async (val: any) => {
      let data = {
        clientId: currentClient?.id,
        ...val,
      };
      let res = await InventoryMasterService?.saveInvMaster(data, id);
      if (res?.status) {
        onCancel(false);
        notification.success({
          message: "Success",
          description: "Master Add successfully.",
        });
        setRefresh((x: boolean) => !x);
      } else {
        notification.error({
          message: "Error",
          description: res?.message,
        });
      }
    });
  };

  return (
    <>
      <Modal
        title="Add Document"
        onCancel={() => onCancel(false)}
        open={openModal}
        footer={
          <div style={{ marginTop: "0px" }}>
            <Button
              onClick={() => onCancel(false)}
              style={{ marginRight: "10px" }}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={saveMasterData}>
              Save
            </Button>
          </div>
        }
      >
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="Document Name">
            <Input />
          </Form.Item>
          <Form.Item name="docType" label="Document Type">
            <Select
              placeholder="Select Type..."
              options={[
                { value: docType.GSTCertificate, label: "GST Certificate" },
                { value: docType.PAN, label: "PAN" },
                { value: docType.TAN, label: "TAN" },
                {
                  value: docType.CIN,
                  label: "CIN",
                },
                { value: docType.ListOfDirectorsPartners, label: "List" },
                {
                  value: docType.UdyamRegistrationCertificate,
                  label: "Udyam Registration Certificate",
                },
                {
                  value: docType.ImportExportCertificate,
                  label: "Import Export Certificate",
                },
                {
                  value: docType.ISOQualityCertificate,
                  label: "ISO Quality Certificate",
                },
                { value: docType.ISICertificate, label: "ISI Certificate" },
                {
                  value: docType.AuditedBalanceSheet,
                  label: "Audited Balance Sheet",
                },
                {
                  value: docType.MemorandumOfAssociation,
                  label: "Memorandum Of Association",
                },
                {
                  value: docType.FactoryRegistrationCertificate,
                  label: "Factory Registration Certificate",
                },
                {
                  value: docType.BankSolvencyForm,
                  label: "Bank Solvency Form",
                },
                {
                  value: docType.BankDetailWithCancelCheque,
                  label: "Bank Detail With Cancel Cheque",
                },
                {
                  value: docType.PlantMachineryList,
                  label: "Plant Machinery List",
                },
                {
                  value: docType.TestingEquipmentsListWithCalibrationStatus,
                  label: "Testing Equipments List With Calibration Status",
                },
                { value: docType.ClientageDetail, label: "Clientage Detail" },
                { value: docType.TurnoverDetails, label: "Turnover Details" },
                {
                  value: docType.PreviousSuppliesDetail,
                  label: "Previous Supplies Detail",
                },
                {
                  value: docType.ListOfDirectorsPartners,
                  label: "List Of Directors Partners",
                },
                { value: docType.ProductDetails, label: "Product Details" },
              ]}
            />
          </Form.Item>

          {/* <Form.Item name="field" label="Field Name">
            <Select
              mode="multiple"
              placeholder="Select Fields..."
              options={[
                { value: Fields.Number, label: "Number" },
                { value: Fields.Upload, label: "Upload" },
                { value: Fields.ExpiryDate, label: "ExpiryDate" },
                {
                  value: Fields.BankName,
                  label: "BankName",
                },
                { value: Fields.Branch, label: "Branch" },
                { value: Fields.AccountNo, label: "AccountNo" },
                { value: Fields.AccountHolderName, label: "AccountHolderName" },
                { value: Fields.AccountType, label: "AccountType" },
                { value: Fields.IFSC, label: "IFSC" },
                { value: Fields.Name, label: "Name" },
                { value: Fields.CalibrationStatus, label: "CalibrationStatus" },
                { value: Fields.Since, label: "Since" },
                { value: Fields.Last1Year, label: "Last1Year" },
                { value: Fields.Last2Year, label: "Last2Year" },
                { value: Fields.Last3Year, label: "Last3Year" },
                { value: Fields.IssuedOn, label: "IssuedOn" },
                { value: Fields.Date, label: "Date" },
                { value: Fields.PONo, label: "PONo" },
              ]}
            />
          </Form.Item> */}

          <Row>
            <Col span={8}>
              <Form.Item
                valuePropName="checked"
                name="showInList"
                label="Show In List"
              >
                <Checkbox />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                valuePropName="checked"
                name="isRequired"
                label="Required"
              >
                <Checkbox />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddInventoryMaster;
